import CustomersLayout from "../layouts/CustomersLayout";

const Customers = () => {
  return (
    <div className="p-8 bg-gray-100">
      <CustomersLayout />
    </div>
  );
};

export default Customers;
